// import {DocumentNode, gql, useMutation} from '@apollo/client'
// import {useState} from 'react'
// import {ScissorsIcon} from '@heroicons/react/outline'
// import Button from './Button'
// import {useSessionStorageState} from '../utils/useSessionStorageState'

import {useEffect, useState} from 'react'
// console.log('shopi', shopifyClient)

// const UPDATE_CROP = gql`
//   mutation UpdateCrop($crop: String!, $orderId: String!, $itemId: Int!) {
//     updateCrop(crop: $crop, orderId: $orderId, itemId: $itemId) {
//       status
//       message
//       execution_time
//     }
//   }
// `
type Props = {
  currentCrop: string
  setNewCrop?: (crop: string) => void
  type?: string
}

const CropAction: React.FC<Props> = ({
  currentCrop,
  setNewCrop,
  type = 'New',
}) => {
  const [newCrop, setnewCrop] = useState([])
  // console.log(newCrop)
  const filteredCrop = newCrop.filter(
    sc => sc.value != 'Select A Crop',
  )

  return (
    <div tw="mt-4">
      {/* <h3 tw="text-lg font-semibold text-brand">{type} Crop</h3> */}
      <h3 tw="text-lg text-brand">{type && type == "Replacement" ? "Replacement Crop" : "Crop"}</h3>
      <div tw="flex-shrink-0 font-normal text-gray-500">
        <div className="select-box" tw="mb-0!">
          <span className="select-icon">
            <i className="fa fa-caret-down"></i>
          </span>
          <select
            // value={
            //   currentCrop != 'Just The Head(s)' &&
            //   currentCrop != 'Entire Body(s)' &&
            //   currentCrop != 'Do Not Crop' &&
            //   currentCrop != "Do Not Crop (we'll keep the photo as is)" &&
            //   currentCrop != 'Just The Car' &&
            //   currentCrop != ''
            //     ? ''
            //     : currentCrop
            // }
            value={
              currentCrop === "Do Not Crop" ? "Do Not Crop (we'll keep the photo as is)" : 
              (["Just The Head(s)", "Entire Body(s)", "Do Not Crop (we'll keep the photo as is)", "Just The Car", ""].includes(currentCrop) ? currentCrop : "")
            }
            onChange={e => setNewCrop(e.currentTarget.value)}
            className="input-styling"
            tw="h-full w-full p-2 bg-white focus:ring-brand"
          >
            <option disabled>Select A Crop</option>
            {/* {filteredCrop.map(el => {
            // console.log(el)
            return (
              <>
                <option key={el.value} value={el.value}>
                  {el.value}
                </option>
              </>
            )
          })} */}              
            <option value="Just The Head(s)">
              Just The Head(s)
            </option>
            <option value="Entire Body(s)">
              Entire Body(s)
            </option>            
            <option value="Just The Car">Just The Car</option>
            <option value="Do Not Crop (we'll keep the photo as is)">
              Do Not Crop (we&apos;ll keep the photo as is)
            </option>
            <option value="">Other</option>
          </select>
        </div>
      </div>
    </div>
  )
}

export default CropAction
